import { apiService } from '../api';
import { StockTransfer, CreateTransferRequest, TransferFilters } from '../../types/inventory';

const BASE = '/inventory/transfers';

export const stockTransferService = {
  async getTransfers(filters: TransferFilters): Promise<StockTransfer[]> {
    const response = await apiService.get<StockTransfer[]>(BASE, filters);
    return response.data;
  },

  async getTransfer(id: string): Promise<StockTransfer> {
    const response = await apiService.get<StockTransfer>(`${BASE}/${id}`);
    return response.data;
  },

  async createTransfer(data: CreateTransferRequest): Promise<StockTransfer> {
    const response = await apiService.post<StockTransfer>(BASE, data);
    return response.data;
  },

  // Complete a transfer — deducts TRANSFER_OUT at source, adds TRANSFER_IN at destination
  async completeTransfer(id: string): Promise<StockTransfer> {
    const response = await apiService.post<StockTransfer>(`${BASE}/${id}/complete`);
    return response.data;
  },

  async cancelTransfer(id: string): Promise<StockTransfer> {
    const response = await apiService.post<StockTransfer>(`${BASE}/${id}/cancel`);
    return response.data;
  },
};
